import { Indicator } from '../../../Common/Charts/Indicator';
import useIndicatorChart from './hooks/useIndicatorChart';

export const IndicatorService = ({ title }) => {
    const { value } = useIndicatorChart(title);

    return <Indicator title={`Indicador de ${title}`} indicatorValue={value} height={200} />;
};
